__turbopack_context__.v({
  "KinoDk": "odllxa_KinoDk",
  "SSearch": "odllxa_SSearch",
  "SSearchButton": "odllxa_SSearchButton",
  "SSearchInput": "odllxa_SSearchInput",
  "SSearchSvg": "odllxa_SSearchSvg",
});
